module.exports = __webpack_public_path__ + "static/img/tongxiangongren.b9db915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/tongxiangongren.jpg
// module id = TzV9
// module chunks = 4